// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1___7f0f7b116766904ddde","cls2":"BulkFollowSuggestion-cls2__b0b0dd698c7cbcc0f885 BulkFollowSuggestion-cls1___7f0f7b116766904ddde"};